import { connect } from "react-redux";
import Media from "../components/media";
import React from "react";
import redirectIfAuthenticated from "../components/higher-order/redirect-if-authenticated";
import { sessionShowLogin } from "../actions/session";
import SignUpForm from "../containers/sign-up-form";

function SignUpPage({ sessionShowLogin: ssl }) {
  if (window.env.customLoginLinks) {
    window.location = window.env.customLoginLinks.signUp;
    return null;
  }
  return (
    <div className="l-main l-row">
      <div className="l-wrapper">
        <div className="l-content l-content--80-percent">

          <h1 className="text-center">
            Create your FREE account.
          </h1>

          <div className="batch-g batch-g--padding">
            <div className="batch-c-1-1 batch-c-md-2-3">
              <SignUpForm />
            </div>

            <div className="batch-c-1-1 batch-c-md-1-3">
              <Media
                hiddenOnMobile
                icon="dw-dollars"
                small
                title="Play for MONEY">
                Enter money games for as little as $1 or higher stakes games for more.
              </Media>

              <Media
                hiddenOnMobile
                icon="dw-points"
                small
                title="Play for FREE">
                Create your FREE account &amp; get 1,000 player points. Use your points to enter free games &amp; get started!
              </Media>

              <hr />

              <p>
                Already have an account?
              </p>

              <button
                className="btn btn--small"
                onClick={ssl}
                type="button">
                Login Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

function select() {
  return {
  };
}

export default connect(select, { sessionShowLogin })(redirectIfAuthenticated(SignUpPage, "/welcome"));
